import React from 'react';

export function UniBielefeld(props) {
  const style={alignSelf:'start', margin:'0 5px'};
  return (
    <div style={style}>
      Universität Kassel, Universität Würzburg & Freie Universität Berlin<br/>
      <br/>
      Dr. Lea Nemeth & Dr. Veit Kubik
    </div>
  );
}
